export const getTeamList = state => state.profileStateReducer.teamList;
export const getSelectedTeam = state => state.profileStateReducer.team;



// WEBPACK FOOTER //
// ./src/store/selector/profile.selector.js